import { ApiPath } from 'common/enums/http/api-path';
import type { ResponseWithPagination } from 'common/types';
import type { TiresMovementsHistory } from 'models/tires-movements-history';
import { http } from 'services/http';

export const getTiresMovementsHistoryApi = (params?: string) =>
  http.get<ResponseWithPagination<TiresMovementsHistory>>(
    `${ApiPath.TIRES_MOVEMENTS_HISTORY}${params || ''}`
  );
